import { HubConnectionBuilder, LogLevel, type HubConnection } from '@microsoft/signalr';
import { authStore } from '@/stores/auth-store';

/**
 * Même base que le client HTTP typé (`api/client.ts`) : l'API est servie sur la même origine
 * que le frontend (proxy Vite en développement, reverse proxy en production), condition déjà
 * posée pour le cookie de rafraîchissement `SameSite=Strict`.
 */
function apiBaseUrl(): string {
  return (
    import.meta.env.VITE_API_BASE_URL ??
    (typeof window === 'undefined' ? 'http://localhost' : window.location.origin)
  );
}

/**
 * Construit (sans démarrer) une connexion SignalR vers le hub des conversations support.
 *
 * `accessTokenFactory` lit le jeton d'accès au moment de la connexion ET de chaque
 * reconnexion automatique — pas de capture figée du jeton courant. Le serveur accepte ce
 * jeton en paramètre de requête `access_token` : le navigateur ne peut pas poser d'en-tête
 * `Authorization` sur la négociation WebSocket.
 */
export function createConversationHubConnection(): HubConnection {
  return new HubConnectionBuilder()
    .withUrl(`${apiBaseUrl()}/hubs/conversations`, {
      accessTokenFactory: () => authStore.getAccessToken() ?? '',
    })
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();
}
